<template>
    <div class="footer">
        <div class="footer-box">
            <div class="item">
                <img src="../assets/add.png" alt="">
                <div>ĐỊA CHỈ</div>
                <p>Plot 500, Map No 28, Section 1,;Hoa Phu Ward Thu Dau Mot Binh Duong</p>
            </div>
            <div class="item">
                <img src="../assets/elm.png" alt="">
                <div>ĐIỆN THOẠI</div>
                <p>support@khshieldcorporation.com</p>
            </div>
            <div class="item">
                <img src="../assets/tel.png" alt="">
                <div>THƯ</div>
                <p>845767690</p>
            </div>
        </div>
        <div class="bottom-sode"></div>
    </div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {
            value: ''
        }
    },
    mounted() {

    },
    methods: {
        sendEmail() {
            if (!this.value) {
                return alert('Email cannot be empty')
            }
            return alert('Sent successfully')
        }
    }
}
</script>


<style lang="less" scoped>
.footer {
    margin-top: 10px;

    .footer-box {
        padding: 0px 140px 0px 140px;
        display: flex;
        align-items: self-start;
        justify-content: space-between;

        .item {
            width: 280px;
            height: 170px;
            padding: 25px 37px;
            background: #FFFFFF;
            box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.1);
            border-radius: 8px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            img {
                width: 40px;
            }

            div {
                font-weight: 900;
                font-size: 16px;
                color: #333333;
                margin-top: 22px;
            }

            p {
                font-size: 18px;
                color: #999999;
                margin-top: 16px;
            }
        }
    }

    .bottom-sode {
        height: 16px;
        background-color: #3BA9F6;
        margin-top: 80px;
    }
}
</style>